import { motion } from 'motion/react';
import * as React from 'react';
import styled from 'styled-components';

import { Toast as CBToast, ToastProps as CBToastProps } from '@creditornot/cb-toast';

import { useToast } from '../../../hooks/useToast';
import { media } from '../../../media';

const MotionRoot = motion.div;

const StyledToast = styled(CBToast)`
  width: 100%;
  max-width: 100%;

  @media ${media.sm} {
    width: auto;
    min-width: 480px;
    max-width: 480px;
  }
`;

export type ToastProps = Omit<CBToastProps, 'children'> & {
  autoClose?: false | number;
  dataTestId?: string;
  description: CBToastProps['children'];
  id: string;
};

export const Toast = ({
  autoClose = 5000,
  dataTestId,
  description,
  id,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonLabel,
  secondaryButtonLabel,
  title,
  variant,
}: ToastProps) => {
  const { removeToast } = useToast();

  React.useEffect(() => {
    if (!autoClose) return;
    const timeoutId = setTimeout(() => {
      removeToast(id);
    }, autoClose);
    return () => clearTimeout(timeoutId);
  }, [id, removeToast, autoClose]);

  return (
    <MotionRoot
      initial={{ opacity: 0.5, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ scale: 0, opacity: 0, transition: { duration: 0.15 } }}
    >
      <StyledToast
        data-test-id={dataTestId}
        onCloseButtonClick={() => {
          removeToast(id);
        }}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onSecondaryButtonClick={onSecondaryButtonClick}
        primaryButtonLabel={primaryButtonLabel}
        secondaryButtonLabel={secondaryButtonLabel}
        title={title}
        variant={variant}
      >
        {description}
      </StyledToast>
    </MotionRoot>
  );
};
